//############ actors.js (in data folder we created) ###########
const bowlingBall =  [
  {
    id: 1,
    ballName: "Melee",
    coreType: "Melee Medium RG Symmetric",
    coverstock: "Savvy Solid Reactive",
    color: "1- Color, Red Solid",
    finishingSteps: "500 Siaair Micro Pad, Royal Compound, Royal Shine",
    weights: "12-16 Pounds",
    rgMax: 2.589,
    rgMin: 2.539,
    rgDifferential: .050,
    description: "The new Savvy Solid reactive coverstock is Brunswick’s latest advancement in performance enhancing additive chemistry. Savvy Solid reactive is formulated to provide maximum versatility on a variety of oil patterns for all types of physical styles. This new formulation produces easy length through the heads and mid-lane, with a forceful backend reaction.",
    price: 165.95,
    imgFull: "https://www.bowlingball.com/images/product/medium/11276_1_.jpg",
    imgFull2: "http://www.bowlwithbrunswick.com/uploads/cache/images/png-headers/Balls/Melee/CORE_Melee_300x300_290_290_c1_c_t_0_0_.png"
  },
  {
    id: 2,
    ballName: "Quantum",
    coreType: "Quantum Mushroom High RG",
    coverstock: "PK 2016 Solid",
    color: "1- Color, Forest Green Solid",
    finishingSteps: "500/1000 Siaair Micro Pad",
    weights: "14-16 Pounds",
    rgMax: 2.610,
    rgMin: 2.557,
    rgDifferential: .0503,
    description: "The new Quantum Forest Green Solid has been designed with 3.5 times more coverstock increasing durability and performance longevity with an amazing pin impact you not only see but hear! Why does more coverstock improve the pin action so much? More coverstock enhances the Coefficient of Restitution which is the ratio of the differences in velocity between two objects before and after a collision. The higher the restitution, the faster the pins will move after being struck by the ball, transferring that increased kinetic energy to the surrounding pins producing greater pin action!",
    price: 139.95,
    imgFull:"https://www.bowlingball.com/images/product/medium/13398_1_.jpg",
    imgFull2: "http://www.bowlwithbrunswick.com/uploads/cache/images/png-headers/Balls/Quantum_Fire_Pearl/CORE_Quantum_Solid-Pearl_Line_15lb_300x300_290_290_c1_c_t_0_0_.png"
  },
  {
    id: 3,
    ballName: "Brute",
    coreType: "Brute Low RG/Low Diffrential Symmetrical",
    coverstock: "Fortify Hybrid Reactive",
    color: "2-Colors, Navy and Light Blue Pearl Hybrid",
    finishingSteps: "500 Siaair Micro Pad, Royal Compound, Royal Shine",
    weights: "12-16 Pounds",
    rgMax: 2.523,
    rgMin: 2.491,
    rgDifferential: .032,
    description: "Fortify Hybrid Reactive coverstock is Brunswick’s hottest creation based off our performance enhancing additive chemistry technology. Fortify Hybrid Reactive combines a new base coverstock with an enhanced additive package that will provide the easiest length with the quickest lateral traction of any coverstock to date.",
    price: 156.95,
    imgFull:"https://www.bowlingball.com/images/product/medium/11711_1_.jpg",
    imgFull2: "http://www.bowlwithbrunswick.com/uploads/cache/images/png-headers/Balls/Brute/CORE_60-105656-93X_Brute_300x300_290_290_c1_c_t_0_0_.png"
  },
  {
    id: 4,
    ballName: "Hammer",
    coreType: "Modified Vibe",
    coverstock: "React-a-Thane",
    color: "1-Colors, Burgandy",
    finishingSteps: "500 Abralon",
    weights: "12-16 Pounds",
    rgMax: 2.75,
    rgMin: 2.57,
    rgDifferential: .029,
    description: "The original Burgundy Hammer from the early 1990's was the earliest and strongest ball of its time; if you needed hook, you turned to the Burgundy. We didn’t set out to give the bowling world another urethane product, we already have the Blue Hammer and you wouldn’t see a lot of difference on today’s lane conditions. Instead, we have brought you the Burgundy Hammer reaction for today's environments. ",
    price: 99.95,
    imgFull:"https://www.bowlingball.com/images/product/medium/11797_1_.jpg",
    imgFull2: "http://d1p268mz1b2hyf.cloudfront.net/res/uploads/products/full/HMR_Burgundy_Core.png"
  },
  {
    id: 5,
    ballName: "Storm IQ",
    coreType: "C Centripetal Control",
    coverstock: "R2S Solid Reactive",
    color: "1-Colors, Midnight Blue",
    finishingSteps: "4000-grit Abralon",
    weights: "12-18 Pounds",
    rgMax: 2.65,
    rgMin: 2.49,
    rgDifferential: .035,
    description: " The Master line features new technology with innovative core designs and coverstock combinations that yield a wide variety of ball reactions. Often you need a stronger core and cover like that of the Modern Marvel, but sometimes lane conditions can get a bit tricky or a little squirrely. When that happens, you need something to calm down the dreaded over-under reaction and get you back in the pocket! ",
    price: 142.95,
    imgFull:"http://tamerbowling.com/wp-content/uploads/2012/05/Storm_IQ-Tour-ball.jpg",
    imgFull2: "https://www.bowlingball.com/images/product/large/11793_2_.jpg"
  },
  {
    id: 6,
    ballName: "DV8 Pitbull",
    coreType: "Pitbull Low RG Asymmetric",
    coverstock: "Compsite Bite",
    color: "1-Colors, Black/Violet/Neon Green",
    finishingSteps: "500/1000 Siaair Micro Pad",
    weights: "12-16 Pounds",
    rgMax: 2.563,
    rgMin: 2.486,
    rgDifferential: .055,
    description: "The DV8 Pitbull has some serious bite. Featuring the new Pitbull Low RG Asymmetric core, which features a high differential for max flare, the Pitbull is a monster on heavy oil. The pins are going down, they're yelling timber. Paired with the Composite Bite Solid reactive coverstock, you're going to see the ball sink its teeth into the lane and rip the pins to shreds. Never has a ball from DV8 created the kind of traction in oil that you'll see from the Pitbull. The DV8 Pitball is a baller's best friend.",
    price: 154.95,
    imgFull:"http://dv8bowling.com/images/balls/60-105865_Pitbull_530x530.png",
    imgFull2: "http://dv8bowling.com/images/accessories/CORE_60-105865_Pitbull_530x530.png"
  },



];

export default bowlingBall;



// WEBPACK FOOTER //
// ./src/data/bowlingball.js